/* eslint-disable internal-rules/no-restricted-design-system-imports */

/* eslint-disable internal-rules/no-restricted-design-system-props */
import type { PropsWithChildren } from 'react';

import { Button } from '@change/ds-core-ui';

type Props = {
	to: string;
	buttonName: string;
};

export function ActionButton({ to, buttonName, children }: PropsWithChildren<Props>) {
	return (
		<div className="z-20000 sticky bottom-0 w-full bg-fill-inverse-strong px-4 py-2 md:static md:mb-[52px] md:bg-transparent md:px-0 md:py-0">
			<Button
				className="w-full md:w-auto"
				variant="primary"
				as="a"
				href={to}
				data-qa={`${buttonName}-button`}
				size="small"
			>
				{children}
			</Button>
		</div>
	);
}
